import { useCallback, useEffect, useState } from "react";

/** Which table columns a person shows, remembered in this browser; columns that did not exist when it was saved start on */
export function usePersistentColumns(key: string, all: string[]) {
  const storageKey = `crm.columns.${key}`;
  const [visible, setVisible] = useState<string[]>(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || "null") as { shown: string[]; known: string[] } | null;
      if (saved && Array.isArray(saved.shown) && Array.isArray(saved.known)) {
        const fresh = all.filter((k) => !saved.known.includes(k));
        return [...saved.shown.filter((k) => all.includes(k)), ...fresh];
      }
    } catch {
      // Storage unavailable or corrupt: show everything
    }
    return all;
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ shown: visible, known: all }));
    } catch {
      // Not critical
    }
  }, [storageKey, visible, all]);

  const has = useCallback((k: string) => visible.includes(k), [visible]);
  return { visible, setVisible, has };
}
